// Helpers d'URL partagés (B6_12) — source unique de construction des URLs absolues et des URLs de
// page profil. `absoluteUrl` vivait dans `messagesToComments.ts` (B8_01) et était recopié en privé
// par plusieurs composants ; l'idiome `/p/${encodeURIComponent(pseudo)}` était dupliqué à 4 points
// d'émission. Cette classe de bug (un point d'émission qui dérive seul → canonical, JSON-LD et
// byline désalignés) a mordu deux fois (Search Console 2026-07, audit Publisher Center 2026-07-29).

// Compose une URL absolue depuis `base` (base + basePath du tenant, ex. `fullBasepathUrl`) et un
// chemin. Le groupe capturant du regex PRÉSERVE le caractère qui précède un `//` accidentel —
// l'ancien `/[^:]\/\//` (sans groupe) mangeait la dernière lettre du domaine (bug B6_03).
export const absoluteUrl = (base: string, path = ''): string =>
  `${base}${path}`.replace(/([^:])\/\//, '$1/');

// Chemin de la page profil, pseudo percent-encodé (espace/accent → forme RFC 3986 valide, celle
// que Next sert réellement). Le param `[pseudo]` arrive DÉCODÉ dans `getStaticProps`/`router.query`
// (Next décode les segments dynamiques) : encoder ici une entrée brute ne double-encode jamais.
export const profilePath = (pseudo: string): string => `/p/${encodeURIComponent(pseudo)}`;

// URL absolue de la page profil — LA source unique pour la canonical, l'og:url, le redirect et les
// JSON-LD (`author.url`, `comment[].author.url`, `Person.url`). Ne jamais recomposer `/p/…` à la main.
export const profileUrl = (base: string, pseudo: string): string =>
  absoluteUrl(base, profilePath(pseudo));
